<template>
  <div v-if="sendOk" class="greetings">
    <h1>{{ translations[browserLang]["title"] }}</h1>
    <div class="greetings-text">
      <p><strong>{{translations[browserLang]["responseTitle"]}}</strong></p>
      <p>&nbsp;</p>
      <p>{{translations[browserLang]["responseLine1"]}}</p>
      <p>{{translations[browserLang]["responseLine2"]}}</p>
      <p>{{translations[browserLang]["responseLine3"]}}</p>
      <p>{{translations[browserLang]["responseLine4"]}}</p>
      <p>{{translations[browserLang]["responseLine5"]}} <span class="blue-link" @click="showModal = true">{{translations[browserLang]["termsLink"]}}</span></p>
      <p>&nbsp;</p>
      <p><button @click="reloadPage">{{ translations[browserLang]["goBack"] }}</button></p>
    </div>
  </div>
  <div v-if="!sendOk">
    <ul id="languages">
      <li><span class="blue-link" @click="browserLang = 'es'">Español</span></li>
      <li><span class="blue-link" @click="browserLang = 'en'">English</span></li>
    </ul>
    <h1>{{ translations[browserLang]["title"] }}</h1>

    <form @submit.prevent="sendForm" method="post">
      <fieldset>
        <legend>
          <h2>{{ translations[browserLang]["formTitle"] }}</h2>
        </legend>
        <div class="form-items-large">
          <ul class="layout-column">
            <li>{{ translations[browserLang]["bulletOne"] }}</li>
            <li>{{ translations[browserLang]["bulletTwo"] }}</li>
            <li>{{ translations[browserLang]["bulletThree"] }}</li>
            <li>{{ translations[browserLang]["bulletFour"] }}</li>
          </ul>
          <p>
            {{ translations[browserLang]["moreText"] }}
          </p>
        </div>
        <div class="form-items-large">
          {{ translations[browserLang]["anonyQuestion"] }}
        </div>
        <div class="form-items">
          <input
            type="radio"
            id="yes"
            name="anonymous"
            value="yes"
            checked
            v-model="anonymous"
            @click="cleanFeedback()"
          />
          <label for="yes">{{ translations[browserLang]["yes"] }}</label>
          <input
            type="radio"
            id="no"
            name="anonymous"
            value="no"
            v-model="anonymous"
          />
          <label for="no">{{ translations[browserLang]["no"] }}</label>
        </div>
      </fieldset>
      <fieldset>
        <legend>
          <h2>{{ translations[browserLang]["commTitle"] }}</h2>
        </legend>

        <div class="form-items-large">
          {{ translations[browserLang]["commQuestion"] }}
        </div>
        <div class="form-items-large">
          <input
            type="radio"
            id="yes"
            name="feedback"
            value="yes"
            v-model="feedback"
          />
          <label for="yes">{{ translations[browserLang]["yes"] }}</label>
          <input
            type="radio"
            id="no"
            name="feedback"
            value="no"
            checked
            v-model="feedback"
            @click="cleanFeedback()"
          />
          <label for="no">{{ translations[browserLang]["no"] }}</label>
        </div>

        <div class="form-items" v-if="feedback === 'yes' && anonymous === 'no'">
          <label for="userName">{{ translations[browserLang]["name"] }}</label>
          <input
            type="text"
            id="userName"
            name="userName"
            v-model.trim="userName"
          />
        </div>
        <div class="form-items" v-if="feedback === 'yes' && anonymous === 'no'">
          <label for="userJobPosition">{{
            translations[browserLang]["jobPosition"]
          }}</label>
          <input
            type="text"
            id="userJobPosition"
            name="userJobPosition"
            v-model.trim="userJobPosition"
          />
        </div>
        <div class="form-items" v-if="feedback === 'yes' && anonymous === 'no'">
          <label for="userWorkCenter">{{
            translations[browserLang]["workCenter"]
          }}</label>
          <input
            type="text"
            id="userWorkCenter"
            name="userWorkCenter"
            v-model.trim="userWorkCenter"
          />
        </div>
        <div class="form-items" v-if="feedback === 'yes' && anonymous === 'no'">
          <label for="userPhone">{{
            translations[browserLang]["phone"]
          }}</label>
          <input
            type="text"
            id="userPhone"
            name="userPhone"
            v-model.trim="userPhone"
          />
        </div>
        <div class="form-items" v-if="feedback === 'yes'">
          <label for="userEmail"
            >{{ translations[browserLang]["email"] }}*</label
          >
          <input
            type="email"
            id="userEmail"
            name="userEmail"
            required
            v-model.trim="userEmail"
          />
        </div>
        <div class="form-items" v-if="feedback === 'yes'">
          <label for="feedbackDetails">{{
            translations[browserLang]["commDetails"]
          }}</label>
          <input
            type="text"
            id="feedbackDetails"
            name="feedbackDetails"
            v-model.trim="feedbackDetails"
          />
        </div>
      </fieldset>
      <fieldset>
        <legend>
          <h2>{{ translations[browserLang]["informedTitle"] }}</h2>
        </legend>
        <div class="form-items">
          <label for="informedName"
            >{{ translations[browserLang]["name"] }}*</label
          >
          <input
            type="text"
            id="informedName"
            name="informedName"
            required
            v-model.trim="informedName"
          />
        </div>
        <div class="form-items">
          <label for="informedJobPosition"
            >{{ translations[browserLang]["simonJobTitle"] }}*</label
          >
          <input
            type="text"
            id="informedJobPosition"
            name="informedJobPosition"
            required
            v-model.trim="informedJobPosition"
          />
        </div>
        <div class="form-items">
          <label for="informedWorkCenter"
            >{{ translations[browserLang]["workCenter"] }}*</label
          >
          <input
            type="text"
            id="informedWorkCenter"
            name="informedWorkCenter"
            required
            v-model.trim="informedWorkCenter"
          />
        </div>
      </fieldset>
      <fieldset>
        <legend>
          <h2>{{ translations[browserLang]["factsTitle"] }}</h2>
        </legend>
        <div class="form-items">
          <label for="informedDate"
            >{{ translations[browserLang]["date"] }}*</label
          >
          <input
            type="date"
            id="informedDate"
            name="informedDate"
            required
            v-model="informedDate"
          />
        </div>
        <div class="form-items-large">
          <label for="message"
            >{{ translations[browserLang]["message"] }}*</label
          >
          <textarea
            id="message"
            name="message"
            rows="10"
            cols="30"
            required
            v-model.trim="message"
          ></textarea>
        </div>
      </fieldset>
      <fieldset>
        <legend>
          <h2>{{ translations[browserLang]["involvedTitle"] }}</h2>
        </legend>
        <div class="form-items">
          <label for="involvedName"
            >{{ translations[browserLang]["name"] }}*</label
          >
          <input
            type="text"
            id="involvedName"
            name="involvedName"
            required
            v-model.trim="involvedName"
          />
        </div>
        <div class="form-items">
          <label for="involvedJobPosition"
            >{{ translations[browserLang]["simonJobTitle"] }}*</label
          >
          <input
            type="text"
            id="involvedJobPosition"
            name="involvedJobPosition"
            required
            v-model.trim="involvedJobPosition"
          />
        </div>
        <div class="form-items">
          <label for="involvedWorkCenter"
            >{{ translations[browserLang]["workCenter"] }}*</label
          >
          <input
            type="text"
            id="involvedWorkCenter"
            name="involvedWorkCenter"
            required
            v-model.trim="involvedWorkCenter"
          />
        </div>
        <div class="form-items-large note">
          <p>{{ translations[browserLang]["moreInformed"] }}</p>
        </div>
      </fieldset>
      <fieldset>
        <legend>
          <h2>{{ translations[browserLang]["situationTitle"] }}</h2>
        </legend>
        <div class="form-items-large">
          <label for="descriptionSituation"
            >{{ translations[browserLang]["descriptionSituation"] }}*</label
          >
          <textarea
            id="descriptionSituation"
            name="descriptionSituation"
            rows="10"
            cols="30"
            required
            v-model.trim="descriptionSituation"
          ></textarea>
        </div>
      </fieldset>

      <fieldset>
        <legend>
          <h2>{{ translations[browserLang]["witnessTitle"] }}</h2>
        </legend>
        <div class="form-items">
          <label for="witnessName">{{
            translations[browserLang]["name"]
          }}</label>
          <input
            type="text"
            id="witnessName"
            name="witnessName"
            v-model.trim="witnessName"
          />
        </div>
        <div class="form-items">
          <label for="witnessJobPosition">{{
            translations[browserLang]["simonJobTitle"]
          }}</label>
          <input
            type="text"
            id="witnessJobPosition"
            name="witnessJobPosition"
            v-model.trim="witnessJobPosition"
          />
        </div>
        <div class="form-items">
          <label for="witnessWorkCenter">{{
            translations[browserLang]["workCenter"]
          }}</label>
          <input
            type="text"
            id="witnessWorkCenter"
            name="witnessWorkCenter"
            v-model.trim="witnessWorkCenter"
          />
        </div>
        <div class="form-items">
          <label for="witnessPhone">{{
            translations[browserLang]["phone"]
          }}</label>
          <input
            type="text"
            id="witnessPhone"
            name="witnessPhone"
            v-model.trim="witnessPhone"
          />
        </div>
        <div class="form-items">
          <label for="witnessEmail">{{
            translations[browserLang]["email"]
          }}</label>
          <input
            type="email"
            id="witnessEmail"
            name="witnessEmail"
            v-model.trim="witnessEmail"
          />
        </div>
        <div class="form-items-large">
          <label for="witnessMoreInfo"
            >{{ translations[browserLang]["witnessMoreInfo"] }} <span class="note">{{ translations[browserLang]["moreWitnessText"] }}</span></label
          >
          <textarea
            id="witnessMoreInfo"
            name="witnessMoreInfo"
            rows="10"
            cols="30"
            v-model.trim="witnessMoreInfo"
          ></textarea>
        </div>
      </fieldset>

      <fieldset>
        <legend>
          <h2>{{ translations[browserLang]["docsTitle"] }}</h2>
        </legend>
        <div class="form-items-large">
          {{ translations[browserLang]["docsQuestion"] }}
        </div>
        <div class="forms-items">
          <input
            type="radio"
            id="sendDocsYes"
            name="sendDocs"
            value="yes"
            v-model="sendDocs"
          />
          <label for="yes">{{ translations[browserLang]["yes"] }}</label>
          <input
            type="radio"
            id="sendDocsNo"
            name="sendDocs"
            value="no"
            checked
            v-model="sendDocs"
            @click="cleanFiles()"
          />
          <label for="no">{{ translations[browserLang]["no"] }}</label>
        </div>
        <div class="form-items-large" v-if="sendDocs === 'yes'">
          <input type="file" multiple id="files" name="files" required />
          <p class="tip">{{ translations[browserLang]["docsTip"] }}</p>
        </div>
        <div class="form-items-large" v-if="sendDocs === 'yes'">
          <label for="docsDescription"
            >{{ translations[browserLang]["docsMessage"] }}*</label
          >
          <textarea
            id="docsDescription"
            name="docsDescription"
            rows="10"
            cols="30"
            required
            v-model.trim="docsDescription"
          ></textarea>
        </div>
      </fieldset>
      <div class="form-items-large">
        <input
          type="checkbox"
          id="privacyTerms"
          name="privacyTerms"
          value="true"
          required
          v-model="privacyTerms"
        />

        <label for="terms">
          {{ translations[browserLang]["privacyAccept"] }}
          <a :href="translations[browserLang]['termsUrl']" target="_blank">{{
            translations[browserLang]["privacyLink"]
          }}</a
          >*</label
        >
      </div>

      <div class="form-items-large">
        <input
          type="checkbox"
          id="terms"
          name="terms"
          value="true"
          required
          v-model="terms"
        />

        <label for="terms">
          {{ translations[browserLang]["termsAccept"] }}
          <span class="blue-link" @click="showModal = true">{{
            translations[browserLang]["termsLink"]
          }}</span
          >*</label
        >
      </div>
      <div class="form-items">
        <button class="button-large">
          {{ translations[browserLang]["send"] }}
        </button>
      </div>
      <div class="print-error" v-if="printError !== null">
        <strong
          >{{ translations[browserLang]["error"] }} ({{ printError }})</strong
        >
      </div>

      <p class="info-text">{{ translations[browserLang]["terms"] }}</p>
    </form>
  </div>

  <div>
    <teleport to="body">
      <transition name="fade">
        <div
          v-if="showModal"
          class="modal-backdrop"
          @click.self="showModal = false"
        >
          <div id="modal" class="modal">
            <slot name="header">
              <h2>{{ translations[browserLang]["modalTitle"] }}</h2>
            </slot>
            <slot name="body">
              <p v-html="translations[browserLang]['modal']"></p>
            </slot>
            <slot name="footer">
              <div class="centered-button">
              <button @click="showModal = false">{{ translations[browserLang]["close"] }}</button>
              </div>
            </slot>
          </div>
        </div>
      </transition>
    </teleport>
  </div>

  <div>
    <teleport to="body">
      <transition name="fade">
        <div
          v-if="isLoading"
          class="modal-backdrop"
        >
          <div class="sending">
            
            <slot name="loader">
              <p>
                <span class="loader"></span>
              </p>
            </slot>
          </div>
        </div>
      </transition>
    </teleport>
  </div>
</template>

<script>
export default {
  name: "the-form",
  data() {
    return {
      translations: {
        es: {
          termsUrl: "https://www.simonelectric.com/aviso-legal",
          anonyTitle: "Comunicación anónima",
          anonyQuestion:
            "¿Desea que su comunicación sea completamente anónima?",
          formTitle: "¿Qué se puede comunicar a través del Canal Ético?",
          bulletOne:
            "Cualquier incumplimiento del Código Ético o del resto de normativa interna, procesos y controles que conforman el Sistema de Compliance de Grupo Simon.",
          bulletTwo: "Cualquier violación de la legislación vigente aplicable.",
          bulletThree:
            "Cualquier contingencia que pueda suponer un riesgo para la reputación de Grupo Simon.",
          bulletFour:
            "Dudas o consultas en relación con la aplicación del Sistema de Compliance.",
          moreText:
            "En todo caso, el contenido de la comunicación debe estar relacionado con conductas o hechos cometidos por parte de profesionales, directivos y terceros con los que se relaciona o vincula profesionalmente Grupo Simon o sobre dudas acerca del Sistema de Compliance.",
          title: "Formulario de comunicaciones del canal ético",
          name: "Nombre y apellidos",
          jobPosition: "Cargo en Grupo Simon",
          workCenter: "Centro de trabajo",
          phone: "Teléfono de contacto",
          email: "Correo electrónico",
          informedTitle:
            "Persona o profesional sobre la que versa el contenido de la comunicación",
          moreInformed: "*Si hay más personas involucradas escríbalo en el apartado Situación",
          simonJobTitle: "Cargo o vinculación con Grupo Simon",
          factsTitle: "Descripción de los hechos objeto de la comunicación",
          date: "Fecha de ocurrencia",
          message: "Exposición clara y detallada de los hechos",
          involvedTitle:
            "Datos de personas o profesionales involucrados en los hechos descritos",
          situationTitle: "Situación",
          descriptionSituation:
            "Descripción de la situación o método por el que se ha tenido conocimiento de los hechos comunicados",
          witnessTitle: "Posibles testigos",
          witnessMoreInfo: "Información complementaria",
          moreWitnessText: "(Si hay más posibles testigos escríbalo aquí)",
          docsTitle: "Documentos",
          docsQuestion: "¿Desea enviar documentos adjuntos?",
          docsMessage: "Explicación de cada documento o archivo que se aporte",
          docsTip:
            "(Puede seleccionar varios ficheros)",
          yes: "Sí",
          no: "No",
          commTitle: "Comunicaciones ulteriores",
          commQuestion:
            "¿Desea comunicarse con la persona u órgano encargado de gestionar su comunicación?",
          commDetails: "Domicilio o lugar seguro",
          termsAccept: "He leído y acepto los ",
          termsLink: "términos y condiciones de uso del canal ético",
          privacyAccept: "He leido el ",
          privacyLink: "Aviso Legal y la Política de Privacidad",
          send: "Enviar",
          terms:
            "El responsable del tratamiento del Canal Ético es Grupo Simon. Se tratarán los datos, que en su caso incluya en el formulario, para la gestión de su solicitud y, en su caso, la investigación de los hechos. Puede acceder a la información completa sobre el tratamiento de sus datos en la Política de Uso del Canal Ético y ejercer sus derechos en materia de protección de datos en la dirección: vía correo electrónico dpo@simonelectric.com o postal Sancho de Avila 66, 08018, Barcelona con la ref. “Protección de Datos”.",
          error:
            "Hubo un error al enviar el formulario.",
          goBack: "Volver",
          close: "Cerrar",
          responseTitle: "¡Muchas gracias por su comunicación!",
          responseLine1: "Le informamos que hemos recibido su comunicación correctamente y que procedemos a estudiarla y a realizar la tramitación oportuna.",
          responseLine2: "Toda la información proporcionada será tratada de forma confidencial. Su identidad, en caso de haberla revelado, no se comunicará a las personas afectadas ni a terceros, salvo en aquellos casos que determine la Ley.",
          responseLine3: "Si lo desea, puede indicar un domicilio, un correo electrónico o un lugar seguro a efectos de recibir notificaciones.",
          responseLine4: "En cualquier caso, puede acudir directamente a los canales externos que las autoridades independientes de protección a los informantes habiliten, tanto a nivel estatal como autonómico.",
          responseLine5: "Puede consultar sus derechos en materia de protección de datos personales y otra información relevante en relación con el Canal Ético en la Política de uso del Canal Ético, accesible a través de la página web corporativa o a través del siguiente enlace:",
          errorWrongFiles: "El tipo de fichero adjunto no está permitido",
          modalTitle: "Política de uso del Canal Ético",
          modal: `<p>
                Grupo Simon tiene habilitado un mecanismo interno para comunicar
                eventuales incumplimientos (Canal Ético) de conformidad con lo
                establecido en Ley 2/2023, de 20 de febrero, reguladora de la
                protección de las personas que informen sobre infracciones
                normativas y de lucha contra la corrupción, así como dudas y
                consultas en relación con la interpretación y aplicación de su
                Sistema de <span class="text-italic">Compliance</span>. </p>
                <h3>¿Qué se puede comunicar a través del Canal Ético?</h3> 
                
                <ul>
                  <li>Cualquier incumplimiento del Código Ético o del resto de normativa interna, procesos y controles que conforman el Sistema de <span class="text-italic">Compliance de Grupo Simon</span></li>
                  <li>Cualquier violación de la legislación vigente aplicable.</li>
                  <li>Cualquier contingencia que pueda suponer un riesgo para la reputación de Grupo Simon.</li>
                  <li>Dudas o consultas en relación con la aplicación del Sistema de <span class="text-italic">Compliance</span>.</li>
                </ul>
                
                <p>En todo caso, el contenido de la comunicación debe
                estar relacionado con conductas o hechos cometidos por parte de
                profesionales, directivos y terceros con los que se relaciona o
                vincula profesionalmente Grupo Simon o sobre dudas acerca del
                Sistema de <span class="text-italic">Compliance</span>.</p>
                <h3>¿En qué consiste el Canal Ético?</h3> 
                <p>El Canal Ético de Grupo Simon consiste en un formulario accesible a
                través de <a href="https://cdn.simonelectric.com/internal-repporting-system/index.html">https://cdn.simonelectric.com/internal-repporting-system/index.html</a>.</p> 
                <h3>Principios y garantías esenciales del uso y gestión del Canal Ético</h3>
                <ul>
                  <li>
                    <strong>Garantía de confidencialidad</strong>: Grupo
                Simon garantiza que (i) la identidad de las personas que
                realicen una comunicación; (ii) la identidad de cualquier otra
                persona afectada o mencionada en la comunicación; y (iii) las
                actuaciones realizadas, tendrán carácter confidencial y no
                podrán ser reveladas ni comunicadas a personas no autorizadas.
                  </li>
                  <li><strong>Anonimato</strong>: las comunicaciones podrán realizarse de forma
                anónima, esto es, sin necesidad de identificarse.</li>
                <li><strong>Prohibición de represalias</strong>: Grupo Simon no adoptará ninguna clase de
                represalia o consecuencia negativa hacia las personas que realicen una comunicación de buena fe.</li>
                <li><strong>Gestión de la comunicación de forma diligente e imparcial.</strong></li>
                <li><strong>Derecho a realizar la comunicación mediante reunión presencial con el
                Responsable del Canal Ético, el Sr. Emili Tunica Guasch</strong>: deberá tener lugar en un plazo máximo de siete (7) días naturales desde
                su solicitud. La reunión presencial deberá en todo caso
                documentarse (i) mediante una grabación de la conversación o
                (ii) a través de una transcripción completa y exacta de la
                conversación. Se podrá escuchar la grabación y/o comprobar,
                rectificar y aceptar, mediante firma, la transcripción de la
                conversación.</li>
                <li><strong>Derecho a acudir a las Autoridades
                Independientes (canal externo)</strong> a través de los mecanismos que
                tengan habilitados.</li>
                <li><strong>Derechos en materia de protección de datos
                personales</strong> de conformidad con el Reglamento (UE) 2016/679 del
                Parlamento Europeo y del Consejo, de 27 de abril de 2016, en la
                Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos
                Personales y garantía de los derechos digitales y en la Ley
                2/2023, de 20 de febrero, reguladora de la protección de las
                personas que informen sobre infracciones normativas y de lucha
                contra la corrupción.</li>
                <li><strong>Otros derechos</strong> recogidos en la Ley
                2/2023, de 20 de febrero, reguladora de la protección de las
                personas que informen sobre infracciones normativas y de lucha
                contra la corrupción.</li>
                </ul>
                <h3>Guía de uso del Canal Ético</h3>
                <p>Sin perjuicio de las garantías y derechos descritos en el apartado anterior,
                resulta importante destacar los siguientes puntos acerca del uso
                del Canal Ético:</p> 
                <ul>
                  <li>El Canal Ético se gestiona por el Responsable
                del Canal Ético, el Sr. Emili Túnica Guasch.</li>
                <li>Tendrán acceso a
                las comunicaciones recibidas a través del Canal Ético: (i) el
                Responsable del Canal Ético; (ii) los miembros del Comité de
                <span class="text-italic">Compliance</span>; (iii) el Departamento de Departamento de Personas &
                Cultura o la persona u órgano competente para adoptar medidas
                disciplinarias; (iv) la responsable del Departamento legal, en
                caso de tener que adoptar medidas legales; (v) en su caso, los
                encargados del tratamiento, por ejemplo, asesores o gestores,
                internos o externos; y (vi) en su caso, el delegado de
                protección de datos.</li>
                <li>Únicamente se podrá hacer uso del Canal
                Ético para comunicar los hechos o consultas referenciadas
                anteriormente (ver punto “¿Qué se puede comunicar a través del
                Canal Ético?”).</li>
                <li>Un mal uso del Canal Ético podrá ser
                sancionado. Por ejemplo, en caso de comunicar hechos falsos o de
                mala fe.</li>
                <li>Todos los profesionales de Grupo Simon tienen la
                obligación de comunicar aquellos incumplimientos del Sistema de
                <span class="text-italic">Compliance</span> o de la legislación aplicable que hayan tenido
                conocimiento.</li>
                </ul>
                <h3>Derechos en materia de protección de datos personales</h3>
                
                  <ol><li><strong>Responsable del tratamiento</strong>
                    <p>Identidad: SIMON, S.A.<br>
                    Domicilio social: Sancho de Avila 66, 08018, Barcelona (España).<br>
                    CIF: A-08078651.</p></li>
                  <li><strong>Finalidad del tratamiento</strong>
                  <p>Los datos personales que se faciliten en la comunicación serán tratados
                con la finalidad de atender y analizar la comunicación,
                investigar los hechos comunicados y adoptar las medidas
                correctivas pertinentes, ya sean disciplinarias o contractuales
                para cumplir con la debida diligencia y control de Grupo Simon.</p></li>
                <li><strong>Categorías de datos personales</strong>
                <p>Los datos personales que Grupo
                Simon tratará son los que el comunicante facilite a través de la
                comunicación, como el resto de los datos que puedan recabarse
                como consecuencia de la investigación que pueda ponerse en
                marcha de acuerdo con el procedimiento indicado para el Canal
                Ético de Grupo Simon.</p></li>
                <li><strong>Carácter anónimo y confidencial</strong>
                <p>El comunicante podrá identificarse, pero también podrá comunicar
                cualquier hecho de forma anónima. En cualquiera de los casos,
                tanto los datos personales como la información, serán tratados
                de forma confidencial.</p>
              <p>Aunque la identificación del comunicante
                no es obligatoria y éste puede optar por no facilitar sus datos
                de identificación o contacto, estos pueden ayudar al desarrollo
                satisfactorio de la investigación. El comunicante puede también
                identificarse en un momento posterior a la interposición de la
                comunicación o aportar en un momento posterior del proceso
                documentación o información adicional.</p>
              <p>Las intervenciones de
                testigos y afectados tendrán carácter estrictamente
                confidencial.</p></li>
                <li><strong>Legitimación</strong>
                <p>La base de legitimación para el
                tratamiento de datos por parte de Grupo Simon de los interesados
                es el interés público (art.6.1.e RGPD) y el cumplimiento de una
                obligación legal (art.6.1.c RGPD).</p></li>
                <li><strong>Conservación</strong>
                <p>Los datos
                serán conservados durante el tiempo imprescindible para decidir
                sobre la procedencia de iniciar una investigación sobre los
                hechos comunicados y, en su caso durante el periodo adicional
                necesario para cumplir con la normativa legal o interna
                aplicable.</p><p>Los datos de quien formula la comunicación y de todas
                las partes intervinientes se conservarán en el Canal Ético
                únicamente durante el tiempo imprescindible para decidir sobre
                la procedencia de iniciar una investigación sobre los hechos
                comunicados, que nunca será superior a tres (3) meses desde el
                envío de la comunicación. Transcurrido dicho plazo máximo, se
                procederá a su supresión del Canal Ético, sin perjuicio de la
                conservación y tratamiento de dichos datos que puede seguir
                llevando a cabo el equipo de investigación para dar curso a la
                investigación.</p><p>Tras la supresión, los datos serán bloqueados
                durante los periodos legalmente previstos.</p></li>
                <li><strong>Comunicación de
                datos</strong>
                <p>
              <ol type="a">
                <li><p>Autoridades que puedan intervenir en la investigación o
                posible procedimiento judicial.</p></li>
                <li><p>Personas que puedan estar
                implicadas en la propia investigación.</p></li>
                <li><p>Fuerzas y Cuerpos de
                Seguridad del Estado y Tribunales competentes.</p></li>
                <li><p>Terceros en
                los que Grupo Simon pueda apoyarse para llevar el Canal Ético,
                por ejemplo: plataforma de alojamiento de datos, herramienta que
                sostiene el Canal Ético, personas a las que se pueda delegar en
                detalle la investigación, abogados u otro tipo de asesores,
                entre otros.</p></li>
              
              </ol>
            </p>
            </li>
            <li><strong>Ejercicio de derechos</strong>
            <p>
              <ol type="a">
                <li><p>Derechos del
                comunicante: En todo momento el comunicante podrá ejercer sus
                derechos de acceso, rectificación, supresión, oposición,
                limitación y portabilidad con respecto a los datos personales
                que haya facilitado, a través de correo postal a la dirección
                indicada o al correo: <a href="mailto:dpo@simonelectric.com" target="_blank">dpo@simonelectric.com</a> aportando copia de
                su DNI o documento equivalente, e identificándose como usuario del servicio de Canal Ético.</p></li>
                <li><p>Derechos de la persona
                involucrada en los hechos comunicados: Derecho a que se le
                comunique en el tiempo más breve posible que se encuentra
                inmerso en un proceso de investigación, fruto de una
                comunicación relativa a él o a su actuación. La citada
                comunicación tendrá el contenido mínimo siguiente: el órgano
                encargado de la gestión, los hechos comunicados, los derechos
                que le asisten y el procedimiento de trámite de la comunicación,
                así como a toda la información relativa al tratamiento de sus
                datos enumerada en el apartado anterior. Derecho de acceso a los
                datos registrados, excepto la identidad del comunicante y la de
                otras personas afectadas por el expediente, y derecho de
                rectificación de los datos personales que sean inexactos o
                incompletos. Asimismo, tendrá derecho a que se le informe de la
                resolución o archivo de la alerta, en su caso. Cuando la
                comunicación a la persona involucrada en los hechos comunicados
                de que ha sido objeto de una comunicación ponga en peligro la
                capacidad de Grupo Simon para investigar o recopilar pruebas de
                manera eficaz, por el riesgo de destrucción o alteración de
                pruebas por parte de la persona afectada por la comunicación,
                esta podrá retrasar dicho deber de información.</p></li>
              </ol>
            </p></li>
                  </ol>
              <p>En caso de considerar vulnerado su derecho a la protección de datos,
                cualquiera de ellos, podrá interponer una reclamación ante la
                Agencia Española de Protección de Datos (<a href="https://www.aepd.es" target="_blank">www.aepd.es</a>).
              </p>`,
        },
        en: {
          termsUrl: "https://www.simonelectric.com/intl/legal-information",
          title: "Communication form of the Ethical Channel",
          formTitle: "What can be reported through the Ethical Channel?",
          bulletOne:
            "Any breach of the Code of Ethics or of any other internal regulation, process or control that make up the Compliance System of Simon Group.",
          bulletTwo: "Any violation of applicable legislation in force.",
          bulletThree:
            "Any contingency that could represent a risk to the reputation of Simon Group.",
          bulletFour:
            "Doubts and queries regarding application of the Compliance System.",
          moreText:
            "In any event, the content of a communication must be related to conducts or acts committed by professionals, executives or third parties with whom there are professional relations or ties to Simon Group, or they must be related to questions about the Compliance System.",
          anonyTitle: "Anonymous Communication",
          anonyQuestion:
            "Would you like your communication to be completely anonymous?",
          name: "Name and surnames",
          jobPosition: "Position at or relationship with Simon Group",
          workCenter: "Work centre",
          phone: "Contact telephone number",
          email: "Email",
          informedTitle:
            "Person or professional who is the object of the content of the communication",
          moreInformed: "*If there are more people involved, indicate this in the Situation section",
          simonJobTitle: "Position at or relationship with Simon Group",
          factsTitle: "Description of the events, object of the communication",
          date: "Date of occurrence",
          message: "Clear and detailed description of the events",
          involvedTitle:
            "Details of the persons or professionals involved in the described events",
          situationTitle: "Situation",
          descriptionSituation:
            "Description of the situation or method whereby you have become aware of the reported events",
          witnessTitle: "Possible witnesses",
          witnessMoreInfo: "Additional information",
          moreWitnessText: "(If there are more possible witnesses, indicate this here)",
          docsTitle: "Documents",
          docsQuestion: "Would you like to send attached documents?",
          docsMessage: "Explanation of each document or file provided",
          docsTip:
            "(You can select multiple files)",
          yes: "Yes",
          no: "No",
          commTitle: "Subsequent communications",
          commQuestion:
            "Would you like to communicate with the person or body in charge of managing your communication?",
          commDetails: "Address or safe place",
          termsAccept: "I have read and agree to the ",
          termsLink: "terms and conditions of use of the Ethical Channel",
          privacyAccept: "I have read the ",
          privacyLink: "Legal Notice and the Privacy Policy",
          send: "Send",
          terms:
            "The data controller of the Ethical Channel is Simon Group. Any data that might be included in the form will be processed for managing your request and, if applicable, for investigating the facts. You can access complete information about the processing of your data in the Policy on Use of the Ethical Channel, and you may exercise your rights related to data protection via email at dpo@simonelectric.com or via postal mail at Sancho de Ávila, 66, 08018, Barcelona, including the reference “Data Protection”.",
          error:
            "There was an error submitting the form.",
          goBack: "Go Back",
          close: "Close",
          responseTitle: "Thank you very much for your communication!",
          responseLine1: "We hereby inform you that we have received your communication correctly and that we will proceed to study it and process it appropriately.",
          responseLine2: "All information provided will be treated confidentially. Your identity, if you have disclosed it, will not be communicated either to affected persons or to any third parties, except for those determined by law.",
          responseLine3: "If you wish, you can indicate a postal address, an email address or a secure place for receiving notifications.",
          responseLine4: "In any event, you can directly use the external channels that are enabled by independent authorities, both national and regional, for the protection of reporting persons.",
          responseLine5: "You can consult your personal data protection rights and other relevant information related to the Ethical Channel in the Policy on use of the Ethical Channel, which can be accessed through the corporate website or through the following link: ",
          errorWrongFiles: "Attachment type not allowed",
          modalTitle: "Terms and conditions of use of the Ethical Channel",
          modal: `<p>
            Simon Group has enabled an internal mechanism (Ethical Channel) for reporting eventual breaches, in accordance with Law 2/2023, of 20 February, regulating the protection of people who report regulatory breaches and the fight against corruption, 
            as well as for clearing up doubts and queries related to the interpretation and application of its <span class="text-italic">Compliance System</span>.</p>
                <h3>What can be reported through the Ethical Channel?</h3> 
                
                <ul>
                  <li>Any breach of the Code of Ethics or of any other internal regulation, process or control that make up the <span class="text-italic">Compliance System of Simon Group</span>.</li>
                  <li>Any violation of applicable legislation in force.</li>
                  <li>Any contingency that could represent a risk to the reputation of Simon Group.</li>
                  <li>Doubts and queries regarding application of the <span class="text-italic">Compliance System</span>.</li>
                </ul>
                
                <p>In any event, the content of a communication must be related to conducts or acts committed by professionals, executives or third parties with whom 
                  there are professional relations or ties to Simon Group, or they must be related 
                  to questions about the <span class="text-italic">Compliance System</span>.</p>
                <h3>What is the Ethical Channel composed of?</h3> 
                <p>The Ethical Channel of Simon Group is composed of a form that is accessible at <a href="https://cdn.simonelectric.com/internal-repporting-system/index.html">https://cdn.simonelectric.com/internal-repporting-system/index.html</a>.</p> 
                <h3>Essential principles and guarantees of use and management of the Ethical Channel</h3>
                <ul>
                  <li>
                    <strong>Guarantee of confidentiality</strong>: Simon Group guarantees that (i) the identity of any persons who communicate any matter through the Ethical Channel, (ii) the identity of any other person who is affected by or mentioned in a communication and (iii) all actions taken will be confidential in nature and may not be disclosed or communicated to unauthorised persons.
                  </li>
                  <li><strong>Anonymity</strong>: communications may be made anonymously, meaning without the need to identify oneself.</li>
                <li><strong>Prohibition of retaliation</strong>: Simon Group will not adopt any kind of retaliation or negative consequence towards persons who report a matter in good faith.</li>
                <li><strong>Diligent and impartial management of communications.</strong></li>
                <li><strong>The right to communicate through an in-person meeting with the Head of the Ethical Channel, Mr Emili Tunica Guasch</strong>: it must take place within the maximum period of seven (7) calendar days as from the date of the request. In any event, an in-person meeting must be documented (i) through a recording of the conversation or (ii) through a complete and exact transcription of the conversation. The recording may be listened to and/or the transcription of the conversation may be checked, rectified and accepted by signing.</li>
                <li><strong>Right to resort to Independent Authorities (external channel)</strong> through the mechanisms that they have enabled.</li>
                <li><strong>Rights regarding personal data protection</strong> in accordance with the provisions set forth in Regulation (EU) 2016/679 of the European Parliament and of the Council, of 27 April 2016; in Organic Law 3/2018, of 5 December, on the Protection of Personal Data and guarantee of digital rights; and in Law 2/2023, of 20 February, regulating the protection of persons who report regulatory violations and on the fight against corruption.</li>
                <li><strong>Other rights</strong> set forth in Law 2/2023, of 20 February, regulating the protection of people who report regulatory breaches and the fight against corruption.</li>
                </ul>
                <h3>Guide for use of the Ethical Channel</h3>
                <p>Without prejudice to the guarantees and rights described in the preceding section, it is important to highlight the following points about use of the Ethical Channel:</p> 
                <ul>
                  <li>The Ethical Channel is managed by the Head of the Ethical Channel, Mr Emili Túnica Guasch.</li>
                <li>The following will have access to the communications received through the Ethical Channel: (i) the Head of the Ethical Channel; (ii) members of the Compliance Committee; (iii) the People & Culture Department or the person or body that is responsible for adopting disciplinary measures; (iv) the Head of the Legal Department, in the event that legal measures have to be adopted; (v) if applicable, those in charge of processing, such as advisors or managers, internal or external; and (vi) if applicable, the data protection officer.</li>
                <li>The Ethical Channel may only be used to communicate events or make the aforementioned queries (see the point “What can be reported through the Ethical Channel?”).</li>
                <li>Improper use of the Ethical Channel could be penalised. For example, in the event of reporting in bad faith or reporting false facts.</li>
                <li>All professionals of Simon Group have the obligation to report breaches of the <span class="text-italic">Compliance System</span> or of applicable legislation of which they may have become aware.</li>
                </ul>
                <h3>Rights regarding personal data protection</h3>
                
                  <ol><li><strong>Data controller</strong>
                    <p>Identity: SIMON, S.A.<br>
                      Registered office: Sancho de Avila, 66, 08018, Barcelona (Spain).<br>
                      CIF (Tax ID Code): A-08078651.</p></li>
                  <li><strong>Purpose of the processing</strong>
                  <p>The personal data that are provided in a communication will be processed for the purpose of dealing with and analysing the communication, investigating the communicated facts and adopting the pertinent corrective measures, whether disciplinary or contractual, to comply with Simon Group’s due diligence and control.</p></li>
                <li><strong>Categories of personal data</strong>
                <p>The personal data that Simon Group will process are those that the reporting party provides through the communication, as well as all other data that could be collected as a consequence of an investigation that might be initiated according to the procedure indicated for the Ethical Channel of Simon Group.</p></li>
                <li><strong>Anonymous and confidential nature</strong>
                <p>The reporting party may identify themself, but they may also anonymously communicate any event. In any case, all personal data and information will be processed confidentially.</p>
              <p>Even though the identification of the reporting party is not mandatory and they may choose not to provide their identification or contact data, such data could help with the satisfactory development of an investigation. A reporting party can also identify themselves at a later time after making the communication or may provide additional documentation or information at a subsequent moment of the process.</p>
              <p>Participation by witnesses and affected persons will be strictly confidential.</p></li>
                <li><strong>Lawful basis</strong>
                <p>The lawful basis for processing the data of data subjects by Simon Group is public interest (Article 6(1)(e) GDPR) and compliance with a legal obligation (Article 6(1)(c) GDPR).</p></li>
                <li><strong>Storage</strong>
                <p>Data will be stored for the time that is necessary for deciding on the applicability of initiating an investigation of the reported facts and, if applicable, during the additional period that is necessary for complying with applicable legal or internal regulations.</p>
                <p>The data of the reporting party and of all other parties that take part will be stored in the Ethical Channel only for the time that is necessary for deciding on the applicability of initiating an investigation about the reported facts, which may never be longer than three (3) months as from when the communication was sent. Once said maximum period has elapsed, data will be erased from the Ethical Channel, without prejudice to the storage and processing of said data that could be carried out by the investigation team during the course of an investigation.</p>
                <p>After erasure, the data will be blocked during the legally provided periods.</p></li>
                <li><strong>Data disclosure</strong>
                <p>
              <ol type="a">
                <li><p>Authorities who could take part in an investigation or possible legal proceeding.</p></li>
                <li><p>People who could be involved in an investigation itself.</p></li>
                <li><p>State Police and Security Forces and competent courts.</p></li>
                <li><p>Third parties who might be used by Simon Group to manage the Ethical Channel, such as data hosting services, a tool that sustains the Ethical Channel, persons to whom details of the investigation may be delegated, lawyers or other types of advisers, among others.</p></li>
              
              </ol>
            </p>
            </li>
            <li><strong>Exercise of rights</strong>
            <p>
              <ol type="a">
                <li><p>1.	Rights of the reporting party: At any time, the reporting party may exercise their rights of access, rectification, erasure, objection, restriction and portability of the personal data they may have provided, via postal mail at the indicated address or via email at <a href="mailto:dpo@simonelectric.com" target="_blank">dpo@simonelectric.com</a> 
                  , attaching therewith a copy of their DNI (National Identity Document) or the equivalent and identifying themself as a user of the Ethical Channel.</p></li>
                <li><p>2.	Rights of the person involved in the communicated events: The right to be notified in the shortest possible time that they are involved in an investigation as a result of a communication pertaining to them or their actions. Said communication will include at least the following content: the body in charge of managing the case, the reported facts, their rights and the communication procedure, as well as all the information pertaining to the processing of their data listed in the preceding section. Right of access to recorded data, except for the identity of the reporting party and that of other persons who might be affected by the case, and the right to rectification of personal data that may be inaccurate or incomplete. Likewise, they will have the right to be informed of the resolution or closure of the incident, as applicable. Whenever the communication to the person involved in the reported events that have been the object of communication might jeopardise the capacity of Simon Group to effectively investigate or collect evidence, due to the risk of destruction or alteration of evidence by the person affected by such communication, Simon Group may delay said duty of information.</p></li>
              </ol>
            </p></li>
                  </ol>
              <p>If you deem that any of your data protection rights have been violated, you may lodge a complaint with the Spanish Data Protection Agency (<a href="https://www.aepd.es" target="_blank">www.aepd.es</a>).
              </p>`,
        },
      },
      browserLang: null,
      anonymous: "yes",
      userName: null,
      userJobPosition: null,
      userWorkCenter: null,
      userPhone: null,
      userEmail: null,
      informedName: null,
      informedJobPosition: null,
      informedWorkCenter: null,
      informedDate: null,
      message: null,
      involvedName: null,
      involvedJobPosition: null,
      involvedWorkCenter: null,
      descriptionSituation: null,
      witnessName: null,
      witnessJobPosition: null,
      witnessWorkCenter: null,
      witnessPhone: null,
      witnessEmail: null,
      witnessMoreInfo: null,
      sendDocs: "no",
      docsDescription: null,
      feedback: "no",
      feedbackDetails: null,
      terms: false,
      privacyTerms: false,
      printError: null,
      sendOk: false,
      files: null,
      showModal: false,
      isLoading: false,
      allowedExtensions: ['jpg','jpeg','png','gif','docx','xlsx','pptx','pdf','txt','mp3','mp4','mov','m4v','3gp'],
      filesOk: false,
    };
  },
  methods: {
    async sendForm() {
      this.printError = null;
      this.isLoading = true;
      const endPoint = "https://mail-delivery-service.simonelectric.com/api/delivery/reporting-system/";
      
      //const endPoint = "https://configurator-workplaces.simonelectric.com:3000/api/v1/delivery";
      //const endPoint = "http://localhost:3000/api/v1/delivery";

      const dataToSend = this.prepareDataToSend();

      if(this.filesOk) {

      const postOptions = {
        method: "POST",
        body: dataToSend,
        redirect: "follow",
      };
      
      try {
        const apiResponse = await fetch(endPoint, postOptions);
      
        const responseData = await apiResponse.json();
        if (!apiResponse.ok) {
          this.isLoading = false;
          const error = new Error(
            responseData.message || "Failed to send request!"
          );
          this.printError = error;
          throw error;
        } else {
          this.isLoading = false;
          this.sendOk = true;
          window.scrollTo(0, 0);
        }
      } catch(e) {
        this.isLoading = false;
        this.printError = e;
      }
    }
    },
    reloadPage() {
      window.scrollTo(0, 0);
      window.location.reload();
    },
    prepareDataToSend() {
      let formData = new FormData();
      if (this.userName !== null) formData.append("userName", this.userName);
      if (this.userJobPosition !== null)
        formData.append("userJobPosition", this.userJobPosition);
      if (this.userWorkCenter !== null)
        formData.append("userWorkCenter", this.userWorkCenter);
      if (this.userPhone !== null) formData.append("userPhone", this.userPhone);
      if (this.userEmail !== null && this.userEmail !== "")
        formData.append("userEmail", this.userEmail);

      if (this.witnessName !== null)
        formData.append("witnessName", this.witnessName);
      if (this.witnessJobPosition !== null)
        formData.append("witnessJobPosition", this.witnessJobPosition);
      if (this.witnessWorkCenter !== null)
        formData.append("witnessWorkCenter", this.witnessWorkCenter);
      if (this.witnessPhone !== null)
        formData.append("witnessPhone", this.witnessPhone);
      if (this.witnessMoreInfo !== null)
        formData.append("witnessMoreInfo", this.witnessMoreInfo);
        if (this.witnessEmail !== null)
        formData.append("witnessEmail", this.witnessEmail);
      if (this.feedbackDetails !== null)
        formData.append("feedbackDetails", this.feedbackDetails);

      formData.append("informedName", this.informedName);
      formData.append("informedJobPosition", this.informedJobPosition);
      formData.append("informedWorkCenter", this.informedWorkCenter);
      formData.append("informedDate", this.informedDate);
      formData.append("message", this.message);
      formData.append("involvedName", this.involvedName);
      formData.append("involvedJobPosition", this.involvedJobPosition);
      formData.append("involvedWorkCenter", this.involvedWorkCenter);
      formData.append("descriptionSituation", this.descriptionSituation);

      if (this.sendDocs === "yes") {
        formData.append("docsDescription", this.docsDescription);
        const fileInput = document.querySelector("#files");
        //console.log(fileInput.files);

        if (fileInput.files.length !== 0) {
          Array.from(fileInput.files).forEach((file) => {
            if(this.checkExtension(file.name)) {
              formData.append("files[]", file);
              this.filesOk = true;
            } else {
              this.filesOk = false;
              this.isLoading = false;
              this.printError = this.translations[this.browserLang]['errorWrongFiles'];
            }
          });
        } else {
          this.filesOk = true;
        }
        
      } else {
        this.filesOk = true;
      }

      return formData;
    },
    cleanFeedback() {
      this.userName = null;
      this.userJobPosition = null;
      this.userWorkCenter = null;
      this.userPhone = null;
      this.userEmail = null;
      this.feedbackDetails = null;
    },
    cleanFiles(){
      this.files = null;
      this.docsDescription = null;
    },
    checkExtension(fileName) {
      const extension = fileName.split('.').pop();
      if (!this.allowedExtensions.includes(extension.toLowerCase())) {
        //console.log(`${extension} is not in the allowed extensions`);
        return false;
      } else {
        return true;
      }
    }
  },
  created() {
    const lang = navigator.browserLanguage || navigator.language;
    if (lang === "es-ES" || lang === "es" || lang === "eu" || lang === "ca") {
      this.browserLang = "es";
    } else {
      this.browserLang = "en";
    }

    //console.log(this.browserLang);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
